import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CampaignsPageRouteView from './pages/CampaignsPageRouteView.vue';
import LiveChatCampaignsPage from './pages/LiveChatCampaignsPage.vue';
import SMSCampaignsPage from './pages/SMSCampaignsPage.vue';
import WhatsAppCampaignsPage from './pages/WhatsAppCampaignsPage.vue';
import WhatsAppCampaignNewPage from './pages/WhatsAppCampaignNewPage.vue';
import VoiceCampaignsPage from './pages/VoiceCampaignsPage.vue';
import VoiceCampaignDetailPage from './pages/VoiceCampaignDetailPage.vue';
import DetectedCampaignsPage from './pages/DetectedCampaignsPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator'],
};

// A voice campaign is the one an agent works: they enter it to be dialled for. What they may do
// inside it is decided by the server - the members of the line's inbox take its calls, and only an
// administrator changes the campaign or its queue.
const voiceMeta = {
  featureFlag: FEATURE_FLAGS.CHANNEL_VOICE,
  permissions: ['administrator', 'agent', 'custom_role'],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'campaigns_ongoing_index', params: to.params };
          },
        },
        {
          path: 'ongoing',
          name: 'campaigns_ongoing_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_livechat_index', params: to.params };
          },
        },
        {
          path: 'one_off',
          name: 'campaigns_one_off_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_sms_index', params: to.params };
          },
        },
        {
          path: 'live_chat',
          name: 'campaigns_livechat_index',
          meta,
          component: LiveChatCampaignsPage,
        },
        {
          path: 'detected',
          name: 'campaigns_detected_index',
          meta,
          component: DetectedCampaignsPage,
        },
        {
          path: 'sms',
          name: 'campaigns_sms_index',
          meta,
          component: SMSCampaignsPage,
        },
        {
          path: 'voice',
          name: 'campaigns_voice_index',
          meta: voiceMeta,
          component: VoiceCampaignsPage,
        },
        {
          path: 'voice/:campaignId',
          name: 'campaigns_voice_detail',
          meta: voiceMeta,
          component: VoiceCampaignDetailPage,
        },
        {
          path: 'whatsapp',
          name: 'campaigns_whatsapp_index',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignsPage,
        },
        {
          path: 'whatsapp/new',
          name: 'campaigns_whatsapp_new',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignNewPage,
        },
      ],
    },
  ],
};

export default campaignsRoutes;
